module.exports = __webpack_public_path__ + "static/img/图片.53dacbc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/图片.png
// module id = 594
// module chunks = 358